export interface FooterLink {
  readonly id: string;
  readonly label: string;
  readonly href: string;
}

export interface FooterSection {
  readonly id: string;
  readonly title: string;
  readonly links: readonly FooterLink[];
}

export interface SocialLink {
  readonly id: string;
  readonly title: string;
  readonly ariaLabel: string;
  readonly href: string;
}

export interface FooterData {
  readonly sections: readonly FooterSection[];
  readonly socialLinks: readonly SocialLink[];
}

export const footerData: FooterData = {
  sections: [
    {
      id: 'discover',
      title: 'Discover',
      links: [
        {
          id: 'about-us',
          label: 'About Us',
          href: '/about'
        },
        {
          id: 'news',
          label: 'News',
          href: '/news'
        },
        {
          id: 'romford',
          label: 'Romford Location',
          href: '/romford'
        },
        {
          id: 'tilbury',
          label: 'Tilbury Location',
          href: '/tilbury'
        },
        {
          id: 'contact',
          label: 'Contact & Locations',
          href: '/contact'
        },
      ]
    },
    {
      id: 'policies',
      title: 'Our Policies',
      links: [
        {
          id: 'privacy-policy',
          label: 'Privacy Policy',
          href: '/privacy-policy'
        },
        {
          id: 'public-services',
          label: 'Public Services',
          href: 'http://www.direct.gov.uk/'
        },
        {
          id: 'inspection-reports',
          label: 'Inspection Reports',
          href: 'http://www.ofsted.gov.uk/'
        },
        {
          id: 'staff-login',
          label: 'Staff Login',
          href: '/staff'
        },
      ]
    }
  ],
  socialLinks: [
    {
      id: 'facebook',
      title: 'Facebook',
      ariaLabel: 'facebook',
      href: 'https://www.facebook.com/p/Great-Child-Nursery-Romford-100063552731450/'
    },
    {
      id: 'instagram',
      title: 'Instagram',
      ariaLabel: 'instagram',
      href: 'https://www.instagram.com/greatchildnursery/?hl=en'
    },
    {
      id: 'mail',
      title: 'Mail',
      ariaLabel: 'mail',
      href: 'mailto:Admin@greatchild.co.uk'
    },
    {
      id: 'phone',
      title: 'Phone',
      ariaLabel: 'phone',
      href: 'tel:00447983133002'
    },
    {
      id: 'whatsapp',
      title: 'WhatsApp',
      ariaLabel: 'whatsapp',
      href: 'https://api.whatsapp.com/send?phone=%2B447983133002&app=facebook&entry_point=page_cta&fbclid=IwY2xjawMEHOFleHRuA2FlbQIxMABicmlkETEyTkVQVTVRZWZwWU1yZFRKAR6AqPKi1tfgL973A9VP2oAlQsuqp6jYgOU_OwZPd0qYZmKJwqOCciF2vNS76A_aem_rgVu-lMZamG50i8XkxXAnQ',
    }
  ]
} as const;
